var _br;
import * as React from "react";
function SvgAlertFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("html", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("head", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("meta", {
    httpEquiv: "Content-Type",
    content: "text/html; charset=utf-8",
    style: {
      fontFamily: "Calibri, verdana"
    }
  }), /*#__PURE__*/React.createElement("meta", {
    httpEquiv: "X-UA-Compatible",
    content: "IE=edge",
    style: {
      fontFamily: "Calibri, verdana"
    }
  }), /*#__PURE__*/React.createElement("meta", {
    name: "viewport",
    content: "width=device-width, initial-scale=1.0",
    style: {
      fontFamily: "Calibri, verdana"
    }
  }), /*#__PURE__*/React.createElement("title", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }), /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, " *, table{font-family: Calibri, verdana}body, td{padding: 0}body, div[style*=\"margin: 16px 0\"]{margin: 0 !important}.outer, .webkit{max-width: 600px}.one-column .contents, .two-column{text-align: center}.footer-column .f-column, .two-column .column{width: 100%; vertical-align: top; display: inline-block}body{background-color: #fff}table{border-spacing: 0; color: #222}img{border: 0}.wrapper{width: 100%; table-layout: fixed; -webkit-text-size-adjust: 100%; -ms-text-size-adjust: 100%}.webkit{margin: 0 auto}.outer{margin: 0 auto; width: 100%; background-color: #f2f2f2}.inner{padding: 0 0 10px}p{margin: 0}a{color: #ee6a56; text-decoration: none}.one-column{padding: 0 30px}.pt30{padding-top: 30px}.one-column .h1{font-size: 50px; font-weight: 600; margin-bottom: 18px}.one-column .h2{font-size: 18px; font-weight: 400; margin-bottom: 12px}.one-column p{font-size: 18px; margin-bottom: 10px}.subscription-icon{padding-bottom: 10px}.subscription-icon img{width: 100%; max-width: 81px; height: auto}.summary{background-color: #fff; padding: 0 30px 20px}.two-column{font-size: 0}.two-column .column{max-width: 240px}.contents{width: 100%}.two-column .contents{font-size: 14px; text-align: center}.two-column .text{padding-top: 0; font-size: 18px; color: #555}.query{padding-bottom: 10px; font-size: 16px; color: #555}.two-column .number{padding-top: 5px; font-size: 20px; line-height: 22px; color: #555}.footer{padding: 20px}.footer-column{margin: 0; font-size: 0}.footer-column .f-column{max-width: 280px}.footer-column .text{padding-top: 0; font-size: 18px; line-height: 22px; color: #000}.footer-column .text a{color: #034fb6}.inner-box{padding: 10px 0}.ptb10{padding: 20px 0}.f-align{text-align: left}@media only screen and (min-device-width: 600px){.border-right{border-right: solid 1px #f2f2f2 !important}.inner-box{padding: 30px 0 !important}.ptb10{padding: 0 !important}.f-align{text-align: right !important}}.payment-box{background-color: #f2f2f2; font-size: 20px; line-height: 22px; color: #555; padding: 30px 10px}.autox_logo, .social-icons-wrap{padding-top: 10px}.align-left{text-align: left}.align-right{text-align: right}.social-icons{margin-left: 5px; display: inline-block}.pt20{padding-top: 20px}")), /*#__PURE__*/React.createElement("body", {
    style: {
      fontFamily: "Calibri, verdana",
      marginTop: "0 !important",
      marginBottom: "0 !important",
      marginRight: "0 !important",
      marginLeft: "0 !important",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      backgroundColor: "#ffffff"
    }
  }, /*#__PURE__*/React.createElement("center", {
    className: "wrapper",
    style: {
      fontFamily: "Calibri, verdana",
      width: "100%",
      tableLayout: "fixed",
      WebkitTextSizeAdjust: "100%",
      msTextSizeAdjust: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "webkit",
    style: {
      fontFamily: "Calibri, verdana",
      maxWidth: 600,
      marginTop: 0,
      marginBottom: 0,
      marginRight: "auto",
      marginLeft: "auto"
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: "outer",
    align: "center",
    bgcolor: "#f2f2f2",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222",
      margin: "0 auto",
      width: "100%",
      maxWidth: 600,
      backgroundColor: "#f2f2f2"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "one-column pt30",
    style: {
      fontFamily: "Calibri, verdana",
      paddingBottom: 0,
      paddingRight: 30,
      paddingLeft: 30,
      paddingTop: 30
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "inner subscription-icon contents",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingRight: 0,
      paddingLeft: 0,
      paddingBottom: 10,
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "'.STATIC_URL.'assets/images/autoX-logo-mailer.png",
    width: 133,
    height: 43,
    alt: "autoX",
    style: {
      fontFamily: "Calibri, verdana",
      borderWidth: 0,
      width: "100%",
      maxWidth: 133,
      height: "auto"
    }
  })))))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "one-column",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 30,
      paddingLeft: 30
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "inner contents",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 10,
      paddingRight: 0,
      paddingLeft: 0,
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "h2",
    style: {
      fontFamily: "Calibri, verdana",
      margin: 0,
      fontSize: 18,
      fontWeight: "normal",
      marginBottom: 12
    }
  }, " Dear '.$name.',"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "Calibri, verdana",
      margin: 0,
      fontSize: 18,
      marginBottom: 10
    }
  }, " We received a request to verify your account. Enter the following code: ", _br || (_br = /*#__PURE__*/React.createElement("br", null))))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri,verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    style: {
      fontFamily: "Calibri,verdana",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "Calibri,verdana",
      margin: 0,
      fontSize: 50,
      fontWeight: "bold",
      marginBottom: 18
    }
  }, " '.$this->_token.'")))))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "one-column",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 30,
      paddingLeft: 30
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "inner contents",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 10,
      paddingRight: 0,
      paddingLeft: 0,
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "Calibri, verdana",
      margin: 0,
      fontSize: 18,
      marginBottom: 10
    }
  }, " Alternatively, you can verify your account directly by clicking on the button below. Link valid for 24 Hours only.")))))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "one-column",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 30,
      paddingLeft: 30
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "inner contents",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 10,
      paddingRight: 0,
      paddingLeft: 0,
      width: "100%",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "'.URL.'user-verify?t='{{token_variable}}'&u='.$user_id.'&redirect_url='.$redirect_url.'",
    style: {
      borderRadius: 10,
      padding: "8px 15px",
      fontSize: 14,
      lineHeight: 18,
      cursor: "pointer",
      minWidth: 150,
      boxSizing: "border-box",
      textAlign: "center",
      padding: "6px 12px",
      backgroundColor: "#eb1f20",
      color: "#fff"
    }
  }, "Verify Account")))))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "one-column",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 30,
      paddingLeft: 30
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "footer",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 20,
      paddingBottom: 20,
      paddingRight: 20,
      paddingLeft: 20
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "query",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingRight: 0,
      paddingLeft: 0,
      paddingBottom: 10,
      fontSize: 16,
      color: "#555555"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "Calibri, verdana",
      margin: 0
    }
  }, "If you didn'.\"\u2019\".'t make this request, ignore this e-mail. For any queries or concerns, write to us at ", /*#__PURE__*/React.createElement("a", {
    href: "mailto:info@autox.com",
    style: {
      fontFamily: "Calibri, verdana",
      color: "#ee6a56",
      textDecoration: "none"
    }
  }, "info@autox.com")))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "footer-column",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      margin: 0,
      fontSize: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "f-column",
    style: {
      fontFamily: "Calibri, verdana",
      width: "100%",
      maxWidth: 280,
      display: "inline-block",
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "footer-inner align-left",
    style: {
      fontFamily: "Calibri, verdana",
      paddingTop: 0,
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: "footer-contents",
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "text",
    style: {
      fontFamily: "Calibri, verdana",
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      paddingTop: 0,
      fontSize: 18,
      lineHeight: 22,
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "Calibri, verdana",
      margin: 0
    }
  }, " Best,"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: "Calibri, verdana",
      margin: 0
    }
  }, " Team autoX"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "autox_logo",
    style: {
      fontFamily: "Calibri, verdana",
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "'.STATIC_URL.'assets/images/autoX-logo-mailer.png",
    width: 133,
    height: 43,
    alt: "autoX",
    style: {
      fontFamily: "Calibri, verdana",
      borderWidth: 0
    }
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "f-column",
    style: {
      fontFamily: "Calibri, verdana",
      width: "100%",
      maxWidth: 280,
      display: "inline-block",
      verticalAlign: "top"
    }
  }, /*#__PURE__*/React.createElement("table", {
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    className: "footer-inner align-right pt20",
    style: {
      fontFamily: "Calibri, verdana",
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      textAlign: "right",
      paddingTop: 20
    }
  }, /*#__PURE__*/React.createElement("table", {
    className: "footer-contents",
    width: "100%",
    style: {
      borderSpacing: 0,
      fontFamily: "Calibri, verdana",
      color: "#222222"
    }
  }, /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    width: 150,
    className: "text f-align",
    style: {
      fontFamily: "Calibri, verdana",
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      textAlign: "left",
      paddingTop: 0,
      fontSize: 18,
      lineHeight: 22,
      color: "#000000"
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://static.autox.com/",
    style: {
      fontFamily: "Calibri, verdana",
      textDecoration: "none",
      color: "#034fb6"
    }
  }, "static.autox.com"))), /*#__PURE__*/React.createElement("tr", {
    style: {
      fontFamily: "Calibri, verdana"
    }
  }, /*#__PURE__*/React.createElement("td", {
    width: 150,
    align: "left",
    className: "social-icons-wrap f-align",
    style: {
      fontFamily: "Calibri, verdana",
      paddingBottom: 0,
      paddingRight: 0,
      paddingLeft: 0,
      textAlign: "left",
      paddingTop: 10
    }
  }, /*#__PURE__*/React.createElement("a", {
    className: "social-icons",
    href: "https://www.facebook.com/autox/",
    style: {
      fontFamily: "Calibri, verdana",
      color: "#ee6a56",
      textDecoration: "none",
      marginLeft: 5,
      display: "inline-block"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "'.UPLOAD_URL.'magazine-thumbs/facebook-mailer-icon.png",
    width: 31,
    height: 31,
    alt: "facebook",
    style: {
      fontFamily: "Calibri, verdana",
      borderWidth: 0
    }
  })), /*#__PURE__*/React.createElement("a", {
    className: "social-icons",
    href: "https://twitter.com/autoX/",
    style: {
      fontFamily: "Calibri, verdana",
      color: "#ee6a56",
      textDecoration: "none",
      marginLeft: 5,
      display: "inline-block"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "'.UPLOAD_URL.'magazine-thumbs/twitter-mailer-icon.png",
    width: 31,
    height: 31,
    alt: "twitter",
    style: {
      fontFamily: "Calibri, verdana",
      borderWidth: 0
    }
  })), /*#__PURE__*/React.createElement("a", {
    className: "social-icons",
    href: "https://www.youtube.com/autoX",
    style: {
      fontFamily: "Calibri, verdana",
      color: "#ee6a56",
      textDecoration: "none",
      marginLeft: 5,
      display: "inline-block"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "'.UPLOAD_URL.'magazine-thumbs/youtube-mailer-icon.png",
    width: 31,
    height: 31,
    alt: "youtube",
    style: {
      fontFamily: "Calibri, verdana",
      borderWidth: 0
    }
  })), /*#__PURE__*/React.createElement("a", {
    className: "social-icons",
    href: "https://www.instagram.com/autoxmag/",
    style: {
      fontFamily: "Calibri, verdana",
      color: "#ee6a56",
      textDecoration: "none",
      marginLeft: 5,
      display: "inline-block"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "'.UPLOAD_URL.'magazine-thumbs/instagram-mailer-icon.png",
    width: 31,
    height: 31,
    alt: "instagram",
    style: {
      fontFamily: "Calibri, verdana",
      borderWidth: 0
    }
  })), "> ")))))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertFeedback);
export default __webpack_public_path__ + "static/media/alert-feedback.1054543c3fe0d9d2577ae1de12fb7620.svg";
export { ForwardRef as ReactComponent };